export default class Item {
	constructor(item = {}) {
		const { value, font_size, align, weight } = item;
		this.value =
			value && typeof value === "string"
				? parseInt(value.replace(/{tfd-|}/g, ""))
				: value;
		this.font_size = font_size;
		this.align = align;
		this.weight = weight;
	}
	getValue() {
		return this.value;
	}
	getFontSize() {
		return this.font_size;
	}
	getAlign() {
		return this.align;
	}
	getWeight() {
		return this.weight;
	}
}
